import { FunctionComponent } from 'react';
import { CertificateData } from '../../types/certificates';
import Certificate from '../Certificates/Certificate';
import { Typography } from '../../tailwindcomponents';
import { NotInterested } from '../../components/icons';
type CertificateProps = {
    validCert: CertificateData | undefined
}

const MyCertificates: FunctionComponent<CertificateProps> = ({ validCert }) => {
    return (
        <div className="w-full">
            {validCert !== undefined ?
                <Certificate
                    setLoading={() => { }}
                    selectedCertificate={validCert}
                    setSelectedCertificate={() => {}}
                    closeCertificate={() => { }}
                    viewType='view'
                    userType='normal'
                    shouldBeAbleToClose={false}
                />
                :
                <div>
                    <div className="flex flex-wrap justify-center">
                        <NotInterested color='error' size={60} />
                    </div>
                    <Typography align='center' variant='h3' margin={[2, 0, 0, 0]} text={"No Certificate"} />
                </div>
            }
        </div>
    )
}

export default MyCertificates;